import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import './employer-certificate-stats.component.scss';

/* ---- Inline lucide-style icons (repo has no lucide-react dependency) ---- */
const stroke = {
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
};

const FileTextIcon = () => (
    <svg width={22} height={22} viewBox="0 0 24 24" {...stroke} aria-hidden="true">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M16 13H8" /><path d="M16 17H8" /><path d="M10 9H8" />
    </svg>
);

const ClockIcon = () => (
    <svg width={22} height={22} viewBox="0 0 24 24" {...stroke} aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </svg>
);

const TrendingUpIcon = () => (
    <svg width={22} height={22} viewBox="0 0 24 24" {...stroke} aria-hidden="true">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
    </svg>
);

export const EmployerCertificateStats: React.FC = () => {
    const { t } = useTranslation();
    const certificates = useSelector(
        (state: any) => state.employerCertificate.employeeCertificates
    ) || [];

    const total = certificates.length;
    const hours = certificates.reduce(
        (sum: number, cert: any) =>
            sum + (cert.employeeWagesDetails || []).reduce(
                (a: number, w: any) => a + (w.hoursworked || 0), 0
            ),
        0
    );
    const active = certificates.filter((cert: any) => cert.isStillEmployed).length;

    const stats = [
        {
            key: 'total',
            label: t('Total Certificates', { defaultValue: 'Total Certificates' }),
            value: total.toLocaleString(),
            variant: 'purple',
            icon: <FileTextIcon />,
        },
        {
            key: 'hours',
            label: t('Hours Recorded', { defaultValue: 'Hours Recorded' }),
            value: `${hours.toLocaleString()}h`,
            variant: 'blue',
            icon: <ClockIcon />,
        },
        {
            key: 'active',
            label: t('Active Contracts', { defaultValue: 'Active Contracts' }),
            value: active.toLocaleString(),
            variant: 'green',
            icon: <TrendingUpIcon />,
        },
    ];

    return (
        <div className="ec-stats">
            {stats.map((s) => (
                <div className={`ec-stats__card ec-stats__card--${s.variant}`} key={s.key}>
                    <div className="ec-stats__info">
                        <span className="ec-stats__label">{s.label}</span>
                        <span className="ec-stats__value">{s.value}</span>
                    </div>
                    <span className="ec-stats__icon">{s.icon}</span>
                </div>
            ))}
        </div>
    );
};
